// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 233 155.05\">\r\n  <path d=\"M0 0v43.141L31.608 63.43 0 82.01v45.277l90.553-53.392V55.101zm110.84 79.45h32.889v39.3H110.84zm0-71.55h32.889v39.3H110.84zm46.77 110.84H233v36.31h-75.39z\"/>\r\n</svg>\r\n";
// Exports
module.exports = code;